import { pipe } from 'ramda';
import { StateStatus } from '@alycecom/utils';

import { IRootState } from '../../../../store/root.types';

const pathToShippingState = (state: IRootState) => state.recipient.shipping;

export const getIsPending = pipe(pathToShippingState, state => state.status === StateStatus.Pending);
export const getErrors = pipe(pathToShippingState, state => state.errors);
export const getIsValidated = pipe(pathToShippingState, state => state.isValidated);
export const getShippingAddress = pipe(pathToShippingState, state => state.address);

export const getVerifiedAddress = pipe(pathToShippingState, state => state.verifiedAddress);
export const getOriginalAddress = pipe(pathToShippingState, state => state.address?.address);
export const getIsAddressVerified = pipe(pathToShippingState, state => state.isAddressVerified);
export const getIsAddressChanged = pipe(pathToShippingState, state => state.isAddressChanged);
export const getIsManualAddressMode = pipe(pathToShippingState, state => state.isManualAddressMode);
